import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, Row } from 'antd';
import { ApiFilled, UserDeleteOutlined, SolutionOutlined } from '@ant-design/icons';
import Loading from 'components/Loading';
import ButtonComponent from 'components/Button';
import { ENUM_STATUS_ATIVO, ENUM_MODAL, USUARIO_LOGADO_FAS } from 'utils/consts';
import { getLabelCargoFas } from 'utils/funcaoPadrao';
import { signOut } from 'services/auth';
import * as S from './styles';

export const ModalAcessoNegado = () => {
  const modalState = useSelector(state => state.app.modalAcessoNegado);
  const atendenteLogado = useSelector(state => state.atendente.atendenteLogado);
  const user = useSelector(state => state.sefaz.userProfile);

  const cargoFaz = getLabelCargoFas(atendenteLogado?.cargoId, atendenteLogado?.isSetorial);

  const chooseModal = () => {
    if (modalState?.title === ENUM_MODAL.CADASTRO_PENDENTE) return renderCadastroPendente();
    if (modalState?.title === ENUM_MODAL.PERFIL_DIVERGENTE) return renderPerfilDivergente();
    if (modalState?.title === ENUM_MODAL.PERFIL_SEM_CADASTRO_NO_FAS) return renderPerfilSemCadastro();
    return null;
  };

  const getMensagemPerfilDivergente = () => {
    return (
      <>
        <S.FraseAcessoNegado marginBottom="10px">
          Olá {user?.given_name?.split(' ')[0]}, seu perfil contem divergências.
        </S.FraseAcessoNegado>
        <S.FraseAcessoNegado>
          Seu perfil no <b>eSefaz</b>, (sistema de autenticação da Sefaz) é de {user?.profile} e no <b>FAS</b>{' '}
          (Formulário de Atendimento Sefaz) o seu perfil atual é de {cargoFaz}, isso gera uma inconsistência, impedindo
          seu acesso ao sistema.
          <br /> <br />
          Para regularizar seu acesso, solicite ao Supervisor para editar suas informações.
        </S.FraseAcessoNegado>
      </>
    );
  };

  const getMensagemPerfilInativo = () => {
    return (
      <>
        <S.FraseAcessoNegado marginBottom="10px">
          Olá {user?.given_name?.split(' ')[0]}, seu perfil está inativo.
        </S.FraseAcessoNegado>
        <S.FraseAcessoNegado>
          Seu perfil cadastrado do FAS está como inativo, isso está impedindo seu acesso ao sistema.
          <br /> <br />
          Para regularizar seu acesso, solicite ao Supervisor para editar suas informações.
        </S.FraseAcessoNegado>
      </>
    );
  };

  const getMensagemPerfilPendenteAprovacao = () => {
    return (
      <>
        <S.FraseAcessoNegado marginBottom="10px">
          Olá {user?.given_name?.split(' ')[0]}, seu perfil está pendente de aprovação.
        </S.FraseAcessoNegado>
        <S.FraseAcessoNegado>
          Seu perfil cadastrado do FAS está pendente, isso está impedindo seu acesso ao sistema.
          <br /> <br />
          Para regularizar seu acesso, solicite ao Supervisor para editar suas informações.
        </S.FraseAcessoNegado>
      </>
    );
  };

  const getMensagemSemPerfilFas = () => {
    return (
      <>
        <S.FraseAcessoNegado marginBottom="10px">
          Olá {user?.given_name?.split(' ')[0]}, seu perfil não está cadastrado no FAS.
        </S.FraseAcessoNegado>
        <S.FraseAcessoNegado>
          Para regularizar seu acesso, solicite ao Supervisor o cadastro de suas informações.
        </S.FraseAcessoNegado>
      </>
    );
  };

  const renderCadastroPendente = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <S.TituloAcessoNegado>Cadastro Pendente de Aprovação</S.TituloAcessoNegado>
        <S.ContainerRowAcessoNegado>
          <div style={{ height: '90px' }}>
            <SolutionOutlined />
          </div>
        </S.ContainerRowAcessoNegado>
        <S.Label>
          {getMensagemPerfilPendenteAprovacao()}
          <br />
          <S.ContainerRowAcessoNegado>
            <Row>
              <ButtonComponent text={'Sair'} clickAction={() => signOut(null, true)} css={{ margin: '5px' }} />
            </Row>
          </S.ContainerRowAcessoNegado>
        </S.Label>
      </div>
    );
  };

  const renderPerfilSemCadastro = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <S.TituloAcessoNegado>Acesso Negado</S.TituloAcessoNegado>
        <S.ContainerRowAcessoNegado>
          <div style={{ height: '90px' }}>
            <UserDeleteOutlined />
          </div>
        </S.ContainerRowAcessoNegado>
        <S.Label>
          {getMensagemSemPerfilFas()}
          <br />
          <S.ContainerRowAcessoNegado>
            <Row>
              <ButtonComponent text={'Sair'} clickAction={() => signOut(null, true)} css={{ margin: '5px' }} />
            </Row>
          </S.ContainerRowAcessoNegado>
        </S.Label>
      </div>
    );
  };

  const renderPerfilDivergente = () => {
    return (
      <div style={{ textAlign: 'center' }}>
        <S.TituloAcessoNegado>Acesso Negado</S.TituloAcessoNegado>
        <S.ContainerRowAcessoNegado>
          <div style={{ height: '90px' }}>
            <ApiFilled />
          </div>
        </S.ContainerRowAcessoNegado>
        <S.Label>
          {modalState?.props?.situacaoId === ENUM_STATUS_ATIVO.ATIVO.value
            ? getMensagemPerfilDivergente()
            : getMensagemPerfilInativo()}
          <br />
          <S.ContainerRowAcessoNegado>
            <Row>
              <ButtonComponent
                text={'Tentar novamente'}
                clickAction={() => {
                  sessionStorage.removeItem(USUARIO_LOGADO_FAS);
                  window.location.reload();
                }}
                css={{ margin: '5px' }}
              />
              <ButtonComponent
                text={'Fazer Login novamente'}
                clickAction={() => signOut(null, true)}
                css={{ margin: '5px' }}
              />
            </Row>
          </S.ContainerRowAcessoNegado>
        </S.Label>
      </div>
    );
  };

  return (
    <Modal
      title={modalState?.title}
      centered
      visible={modalState?.isOpen}
      onCancel={() => {}}
      width={modalState?.props?.width ?? 800}
      closable={false}
    >
      <Loading>{chooseModal()}</Loading>
    </Modal>
  );
};

export default ModalAcessoNegado;
